import React, { useEffect, useState } from 'react';

import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import "./SingleLevel.css";

const SingleLevel = ({ item }) => {

   const [camData, setCamData] = useState("");
   // const [menuActive,setmenuActive]
   var animTime = 1;
   var cameraType = null;
   const handlecameraClick = (divname, itemtype) => {
      
      window.currentPosition='';
      
      if (window.mob) {
         window.scene._bDoF = false;

      } else {

         window.scene._bDoF = true;
      }
      if(itemtype!=='Skins'){
         if (window.functionClick) return false;
      window.functionClick = true;
      window.scene.groupApplyState('Skin_off');
      if (itemtype == 'exterior') {
         window.scene.groupApplyState("Screen_fill_ON");

      }
      if (itemtype == 'interior') {
         window.removeSkins();

      }
      window.scene._nav._panMax = [10, 10];//[left, bottom];
      window.scene._nav._panMin = [-10, -10];//[right, top];
      window.scene._nav._navMinDolly = 55
      window.openCloseOnOff = false;
      if (divname !== 'Render_Cam_F60_Thermal') {
         window.scene.animPlayAllChildrenInTime("FAN_A", 2.5, 0);
         window.scene.animPlayAllChildrenInTime("FAN_B", 2.5, 0);
      }
      document.getElementById('openCloseAnimAr').src = "img/Lid_open.svg";
      document.getElementById('openCloseAnimAr').src = "img/Lid_open.svg";
      document.getElementById("footProntNote").style.display = 'none';
      if (!divname) {
         return false;
      }
      if (window.menuClick == false) {
         return false;
      }

      var isActive = document.getElementById(divname)
      // console.log(divname)
      // if (window.mob && window.innerHeight > window.innerWidth && isActive.classList.contains('active')) {
      //    document.getElementById(divname).classList.remove('active');
      // }
      if (isActive.classList.contains('active')) {
         if(window.mob || (window.isipad && window.innerHeight > window.innerWidth)){
            
               document.getElementById(divname).classList.remove('active');
            }
      }
      else {
         const collection = document.getElementsByClassName("menu");
         for (let i = 0; i < collection.length; i++) {
            collection[i].classList.remove('active');
         }

         document.getElementById(divname).classList.add('active');
      }


      if (window.mob || window.isipad || window.innerWidth < 818 || window.innerHeight < 818) {
         const arrow = document.getElementsByClassName("content1");
         for (let i = 0; i < arrow.length; i++) {
            if (arrow[i].getAttribute('id') !== "content1-" + divname + "") {
               arrow[i].style.maxHeight = null
            }
         }
         var content = document.getElementById("content1-" + divname + "");
         if (content.style.maxHeight) {
            content.style.maxHeight = null;
         } else {
            content.style.maxHeight = content.scrollHeight + "px";
         }

      }
      console.log(divname)

      if (divname === "FHD_Webcam_Closeup_F12") {
         cameraType = 'exterior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.FHD_Webcam_Closeup_F12) }
         else { window.FHD_Webcam_Closeup_F12() }

         window.selectedMenu.active = 'FHD_Webcam_Closeup_F12';

      }
      else if (divname === "Footprint_F16_New") {
         document.getElementById("footProntNote").style.display = 'block';

         cameraType = 'exterior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Footprint_F16_New) }
         else { window.Footprint_F16_New() }

         window.selectedMenu.active = 'Footprint_F16_New';
         window.scene._nav._panMin = [-10, 14];//[right, top];
         window.scene._nav._panMax = [10, 25];//[left, bottom];

         // window.scene.setDoFTargetObject("RZ_1655-0");

      }
      else if (divname === "Keyboard_F13") {
         cameraType = 'exterior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Keyboard_F13) }
         else { window.Keyboard_F13() }

         window.selectedMenu.active = 'Keyboard_F13';

      }
      else if (divname === "Precision_Glass_Touchpad_F13") {
         cameraType = 'exterior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Precision_Glass_Touchpad_F13) }
         else { window.Precision_Glass_Touchpad_F13() }

         window.selectedMenu.active = 'Precision_Glass_Touchpad_F13';

      }
      else if (divname === "Reset_View_F14") {
         cameraType = 'exterior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Reset_View_F14) }
         else { window.Reset_View_F14() }

         window.selectedMenu.active = 'Reset_View_F14';

      }
      else if (divname === "Ultra_Connectivity_01_F13") {
         cameraType = 'exterior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Ultra_Connectivity_01_F13) }
         else { window.Ultra_Connectivity_01_F13() }

         window.selectedMenu.active = 'Ultra_Connectivity_01_F13';

      }
      else if (divname === "Ultra_Connectivity_02_F14") {
         cameraType = 'exterior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Ultra_Connectivity_02_F14) }
         else { window.Ultra_Connectivity_02_F14() }

         window.selectedMenu.active = 'Ultra_Connectivity_02_F14';
         window.scene._nav._panMax[0] = [20];//[left, bottom];
      }
      else if (divname === "Ultra_Thin_Bezel_Display_F14") {
         cameraType = 'exterior';
         window.scene._bDoF = false;
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Ultra_Thin_Bezel_Display_F14) }
         else { window.Ultra_Thin_Bezel_Display_F14() }

         window.selectedMenu.active = 'Ultra_Thin_Bezel_Display_F14';

      }
      else if (divname === "Render_Cam_F60_Chasis") {
         cameraType = 'exterior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F60_Chasis) }
         else { window.Render_Cam_F60_Chasis() }

         window.selectedMenu.active = 'Render_Cam_F60_Chasis';
         window.scene._nav._panMin = [-10, -14];//[right, top];
         // window.scene._nav._panMax = [10,25];//[left, bottom];

      }
      else if (divname === "Render_Cam_F60_Heat_Compound") {
         cameraType = 'interior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F60_Heat_Compound) }
         else { window.Render_Cam_F60_Heat_Compound() }
         window.scene._nav._panMax[1] = [11];//[left, bottom];
         window.selectedMenu.active = 'Render_Cam_F60_Heat_Compound';

      }
      else if (divname === "Render_Cam_F60_Processor") {
         cameraType = 'interior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F60_Processor) }
         else { window.Render_Cam_F60_Processor() }

         window.selectedMenu.active = 'Render_Cam_F60_Processor';

      }
      else if (divname === "Render_Cam_F60_RAM") {
         cameraType = 'interior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F60_RAM) }
         else { window.Render_Cam_F60_RAM() }

         window.selectedMenu.active = 'Render_Cam_F60_RAM';

      }
      else if (divname === "Render_Cam_F60_Thermal") {
         cameraType = 'interior';

         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F60_Thermal) }
         else { window.Render_Cam_F60_Thermal() }
         window.selectedMenu.active = 'Render_Cam_F60_Thermal';

      }
      else if (divname === "Render_Cam_F60_Exhaust_Fins") {
         cameraType = 'interior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F60_Exhaust_Fins) }
         else { window.Render_Cam_F60_Exhaust_Fins() }

         window.selectedMenu.active = 'Render_Cam_F60_Exhaust_Fins';
         window.scene._nav._panMin = [-15, -10];//[right, top];

      }
      else if (divname === "Render_Cam_F60_Battery") {
         cameraType = 'interior';
         if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F60_Battery) }
         else { window.Render_Cam_F60_Battery() }

         window.selectedMenu.active = 'Render_Cam_F60_Battery';

      }
      GotoPosInTimeNamedValue(item.cameraName, function () {
         window.selectedMenu.cameraType = cameraType;
         window.fadeOut();
      });
   }else{

      const collection = document.getElementsByClassName("skin_menu");
      document.getElementById("Skins").classList.remove('MuiCollapse-hidden');
      document.getElementById("Skins").classList.add('MuiCollapse-entered');
      document.getElementById("Interior").classList.remove('MuiCollapse-entered');
      document.getElementById("Interior").previousSibling.classList.remove('menuActive');
      document.getElementById("Exterior").classList.remove('MuiCollapse-entered');
      document.getElementById("Exterior").previousSibling.classList.remove('menuActive');
      document.getElementById("Skins").previousSibling.classList.add('menuActive');
      for (let i = 0; i < collection.length; i++) {
         collection[i].classList.remove('active');
      }
      window.changeSkin(divname);
      // document.getElementById(divname).classList.add('active');
   }
      window.fRotMinLimitVal = 0.02;

   }
   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname, onComplete, onSample) => {
      // below code is updated in it.  
      // updated code ends here

      var opt = undefined;
      if (!window.mob) {
         var gp = camData[gotoposname];
      } else {
         var gp = window.mobPositions[gotoposname];
      }


      //    console.log(gp)
      if (gp.fovy && window.scene.fovy !== gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }

      gp.time = animTime;
      window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4], 2000, onComplete, slowinout2, opt);
   }
   //end
   function slowinout2(x) {
      var a = 4.0;
      var x2 = 1.0 - x;
      var px = Math.pow(x, a);
      var px2 = Math.pow(x2, a);
      return px / (px + px2);
   }
   const GetData = async () => {

      await fetch('model_gl/config.json'
         , {
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      ).then((response) => response.json())
         .then((myJson) => {
            setCamData(myJson.positions);
         })
   }
   useEffect(() => {
      GetData();
   }, []);

   return (
      item.type!=='Skins'?<div className={`menu`} id={item.id}>
      <ListItem button className='collapsible' onClick={() => { handlecameraClick(item.id, item.type) }}>
         <div className='accordia_icon'>
            <img className='arrow' src='img/spacer.png' id={`accordianIcon_${item.id}`} />
         </div>
         <ListItemText primary={item.title} />
      </ListItem>

      <div className="content1" id={`content1-${item.id}`}>
         <div id={`hotspot_${item.id}`}>

            {item.content && item.content.map((child, key) => (
               <div key={key}>
                  <p>{child.heading}</p>
                  <h5 >
                     {child.text}
                  </h5>
               </div>
            ))
            }
            {(window.mob || window.isipad && window.innerHeight > window.innerWidth) && item.content && item.id == 'Ultra_Connectivity_02_F14' ?
               <div><div className="ports_div">
                  <div id="left_ports" className="">
                     <ol>
                        <li><b>5.</b> Power</li>
                        <li><b>6.</b> Type-A (3.2 Gen 2)</li>
                        <li><b>7.</b> Type-C (3.2 Gen 2 Charge - DP)</li>
                        <li><b>8.</b> 3.5mm Combo</li>
                     </ol>
                  </div>
                  <div id="right_ports" className="active">
                     <ol>
                        <li><b>1.</b> Type-C (3.2 Gen 2 Charge - DP)</li>
                        <li><b>2.</b> Type-A (3.2 Gen 2)</li>
                        <li><b>3.</b> HDMI 2.1 (Up to 4K 120Hz)</li>
                        <li><b>4.</b> Lock</li>
                     </ol>
                  </div>
               </div><div id="main_mob"><div id="ultra_connectivity_left_ports_mob">Left</div><div id="ultra_connectivity_right_ports_mob" className="active">Right</div></div>
               </div>
               : ''}
            {(window.mob || window.isipad && window.innerHeight > window.innerWidth) && item.content && item.id == 'Render_Cam_F60_RAM' ? <div id="memorydiv">
               <div id="ssd_mob" className="">Storage </div>
               <div id="ram_mob" className="active">Memory </div>
            </div>
               : ''}
         </div>
      </div>
      <hr className="separator" />
   </div>
   : <div className={`skin_menu`} id={item.id}>
   <ListItem button  onClick={() => { handlecameraClick(item.id, item.type) }} title={item.name}>
      <div className='skin_icon'>
         <img className='' src={item.icon}  />
      </div>
   </ListItem>
   </div>
   );
};
export default SingleLevel